import type { LineItemFieldKey } from '@snap-types/models/auto-configurator/state';

export const lineItemDependencies: Partial<
  Record<LineItemFieldKey, LineItemFieldKey[]>
> = {
  material: [
    'headStyle',
    'threadSize',
    'threadPitch',
    'surfaceFinish',
    'postFinish',
  ],
  fastenerType: ['threadSize', 'threadPitch'],
  threadSize: ['threadPitch'],
  surfaceFinish: ['postFinish'],
};
